import {
  BANNER_AGENT_JOB_APPLICATION, BANNER_SELL_PROPERTY, BANNER_BUY_PROPERTY, BANNER_EVALUATION, BANNER_BUYER_CONSULTANCY, BANNER_FRANCHISING,
} from '../client/themes/icons';
import { JOIN_OUR_AGENTS_AS, JOIN_OUR_AGENTS_URL } from '../client/utils/links';
import { Adv } from '../domain/adv';
import { AdvFluidType } from '../domain/graphcms';

const advs: { [key in AdvFluidType]: Adv } = {
  [AdvFluidType.AGENT_JOB_APPLICATION]: {
    type: AdvFluidType.AGENT_JOB_APPLICATION,
    symbolPath: BANNER_AGENT_JOB_APPLICATION,
    title: 'Sei un agente immobiliare?',
    description: 'Entra in Dove.it! Per te commissioni fino al 70%, appuntamenti di valutazione già fissati e tecnologia per migliorare il tuo lavoro.',
    cta: 'Invia la tua candidatura',
    urlObject: {
      url: JOIN_OUR_AGENTS_URL,
      as: JOIN_OUR_AGENTS_AS,
    },
  },
  [AdvFluidType.SELL_PROPERTY]: {
    type: AdvFluidType.SELL_PROPERTY,
    symbolPath: BANNER_SELL_PROPERTY,
    title: 'Vuoi vendere casa?',
    description: 'Dove.it vende la tua casa al miglior prezzo, in poche settimane e a ZERO COMMISSIONI',
    cta: 'Vendi con Dove.it',
    urlObject: {
      url: '/sell-property',
      as: '/vendere-casa',
    },
  },
  [AdvFluidType.FRANCHISING]: {
    type: AdvFluidType.FRANCHISING,
    symbolPath: BANNER_FRANCHISING,
    title: "Hai un'agenzia immobiliare?",
    description: 'Appuntamenti di valutazione, portali gratuiti, tecnologia e nessuna entry fee o limiti di zona!',
    cta: 'Scopri il franchising Dove.it',
    urlObject: {
      url: '/franchising',
      as: '/franchising-immobiliare',
    },
  },
  [AdvFluidType.BUY_PROPERTY]: {
    type: AdvFluidType.BUY_PROPERTY,
    symbolPath: BANNER_BUY_PROPERTY,
    title: 'Vuoi comprare casa?',
    description: 'Dove.it ti aiuta a trovare la casa giusta al giusto prezzo!',
    cta: 'Inizia la ricerca',
    urlObject: {
      url: '/buy-property',
      as: '/comprare-casa',
    },
  },
  [AdvFluidType.EVALUATION]: {
    type: AdvFluidType.EVALUATION,
    symbolPath: BANNER_EVALUATION,
    title: 'Sai quanto vale la tua casa?',
    description: 'Ottieni una valutazione gratuita e immediata dai nostri esperti',
    cta: 'Valuta online',
    urlObject: {
      url: '/evaluation',
      as: '/valutazione-immobile',
    },
  },
  [AdvFluidType.BUYER_CONSULTANCY]: {
    type: AdvFluidType.BUYER_CONSULTANCY,
    symbolPath: BANNER_BUYER_CONSULTANCY,
    title: 'Stai comprando la casa giusta?',
    description: 'Ottieni una seconda opinione da un consulente esperto che ti affiancherà dalla valutazione al rogito.',
    cta: 'Chiedilo a noi',
    urlObject: {
      url: '/buyer-consultancy',
      as: '/comprare-casa/consulente-acquisto',
    },
  },
};

export default advs;
